var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_61)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5425 26.1849C48.758 26.301 49.588 26.7724 50.3868 27.2323C53.7275 29.156 57.7047 30.8436 62.4558 32.3532C64.285 32.9343 64.5625 33.0688 64.7678 33.4729C64.9669 33.8645 65.0011 35.3254 65 43.3917C64.9992 48.6254 64.929 53.4704 64.8426 54.2373C64.5711 56.6484 63.5232 59.0381 62.1504 60.3768C61.5405 60.9715 58.9195 62.8279 52.8194 66.9855C49.6549 69.1424 48.2694 70 47.9495 70C47.6275 70 46.1437 69.0711 42.6537 66.6846C33.7627 60.6051 33.1223 60.0774 32.1353 58.0157C31.0504 55.7497 31.0881 56.2125 31.0272 44.3875C30.9722 33.6919 30.9722 33.6903 31.3042 33.2609C31.4868 33.0246 31.7324 32.8313 31.85 32.8313C32.282 32.8313 37.7065 30.9409 39.5902 30.1341C41.7583 29.2052 44.7173 27.7259 46.5201 26.6697C47.8222 25.9067 47.9634 25.8729 48.5425 26.1849Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5425 31.1849C53.758 31.301 54.588 31.7724 55.3868 32.2323C58.7275 34.156 62.7047 35.8436 67.4558 37.3532C69.285 37.9343 69.5625 38.0688 69.7678 38.4729C69.9669 38.8645 70.0011 40.3254 70 48.3917C69.9992 53.6254 69.929 58.4704 69.8426 59.2373C69.5711 61.6484 68.5232 64.0381 67.1504 65.3768C66.5405 65.9715 63.9195 67.8279 57.8194 71.9855C54.6549 74.1424 53.2694 75 52.9495 75C52.6275 75 51.1437 74.0711 47.6537 71.6846C38.7627 65.6051 38.1223 65.0774 37.1353 63.0157C36.0504 60.7497 36.0881 61.2125 36.0272 49.3875C35.9722 38.6919 35.9722 38.6903 36.3042 38.2609C36.4868 38.0246 36.7324 37.8313 36.85 37.8313C37.282 37.8313 42.7065 35.9409 44.5902 35.1341C46.7583 34.2052 49.7173 32.7259 51.5201 31.6697C52.8222 30.9067 52.9634 30.8729 53.5425 31.1849Z",
    fill: "url(#paint1_linear_1062_61)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5425 31.1849C53.758 31.301 54.588 31.7724 55.3868 32.2323C58.7275 34.156 62.7047 35.8436 67.4558 37.3532C69.285 37.9343 69.5625 38.0688 69.7678 38.4729C69.9669 38.8645 70.0011 40.3254 70 48.3917C69.9992 53.6254 69.929 58.4704 69.8426 59.2373C69.5711 61.6484 68.5232 64.0381 67.1504 65.3768C66.5405 65.9715 63.9195 67.8279 57.8194 71.9855C54.6549 74.1424 53.2694 75 52.9495 75C52.6275 75 51.1437 74.0711 47.6537 71.6846C38.7627 65.6051 38.1223 65.0774 37.1353 63.0157C36.0504 60.7497 36.0881 61.2125 36.0272 49.3875C35.9722 38.6919 35.9722 38.6903 36.3042 38.2609C36.4868 38.0246 36.7324 37.8313 36.85 37.8313C37.282 37.8313 42.7065 35.9409 44.5902 35.1341C46.7583 34.2052 49.7173 32.7259 51.5201 31.6697C52.8222 30.9067 52.9634 30.8729 53.5425 31.1849Z",
    stroke: "url(#paint2_linear_1062_61)",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1245 54.838L46.4869 51.0056L44 53.4693L50.1245 60L61 48.6592L58.5502 46L50.1245 54.838Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_61",
    x: 33.85,
    y: 28.85,
    width: 38.3,
    height: 48.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_61"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_61",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_61",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_61",
    x1: 66.3616,
    y1: 35.0595,
    x2: 26.2461,
    y2: 51.1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_61",
    x1: 50.1667,
    y1: 38.3333,
    x2: 30.8375,
    y2: 73.1844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.52c7c3a469258ebc10272aa0efc43599.svg";
export { ForwardRef as ReactComponent };